import { CASES } from "./constants";

/**
 * Updates rate card-related state in the Redux store.
 * @param {Object} payload - State properties to merge into the rateCards slice
 */
export const updateRateCards = (payload) => {
  return { type: CASES.UPDATE_RATE_CARDS, payload };
};

/**
 * Updates a specific field in the rate cards search form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'filterForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateRateCardsSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_RATE_CARDS_SEARCH_FORM,
    payload: { key, data },
  };
};

/**
 * Updates a specific field in the rate card create/edit form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'rateCardForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateRateCardForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_RATE_CARD_FORM,
    payload: { key, data },
  };
};

/**
 * Resets the rate cards state to initial values, preserving sort preference.
 */
export const clearRateCards = () => {
  return { type: CASES.CLEAR_RATE_CARDS, payload: {} };
};

/**
 * Resets the rate card form and drawer-related state, preserving grid data.
 */
export const clearRateCardForm = () => {
  return { type: CASES.CLEAR_RATE_CARD_FORM, payload: {} };
};
